/*****************************************************
Naam: DashboardSideButtons.jsx
Locatie: src/components/Dashboard/DashboardSideButtons.jsx
Datum: 2026-02-07
Versie: 1.0.0
******************************************************
Beschrijving:
Side buttons: Notifications, Email Check, Settings, Logout.
******************************************************/

import React from 'react';
import { Mail, Settings, LogOut, MessageSquare } from 'lucide-react';

const DashboardSideButtons = ({ 
  getButtonStyle,
  notificationCount,
  berichtenCount,
  onOpenNotifications,
  onOpenEmailCheck,
  onOpenSettings,
  onLogout,
  onOpenBerichten
}) => {
  return (
    <>
      {/* Berichten knop */}
      <button
        onClick={onOpenBerichten}
        className="fixed bottom-[296px] right-8 text-white p-4 rounded-full shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300 w-16 h-16 flex items-center justify-center z-50"
        style={berichtenCount > 0
          ? { backgroundColor: '#059669', boxShadow: '0 8px 20px rgba(0,0,0,0.4)' }
          : getButtonStyle('berichten')
        }
        title="Klantberichten"
      >
        <MessageSquare className="w-8 h-8" />
        {berichtenCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center animate-pulse border-2 border-white shadow-lg">
            {berichtenCount > 99 ? '99+' : berichtenCount}
          </span>
        )}
      </button>

      {/* Email Check Button */}
      <button
        onClick={onOpenEmailCheck}
        className="fixed bottom-[216px] right-8 bg-blue-500 hover:bg-blue-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300 w-16 h-16 flex items-center justify-center z-50"
        title="Check Emails"
      >
        <Mail className="w-8 h-8" />
      </button>

      {/* Settings gear wheel */}
      <button
        onClick={onOpenSettings}
        className="fixed bottom-[136px] right-8 text-white p-4 rounded-full shadow-lg hover:shadow-xl transform hover:rotate-90 transition-all duration-300 w-16 h-16 flex items-center justify-center z-50"
        style={getButtonStyle("instellingen")}
        title="Instellingen"
      >
        <Settings className="w-8 h-8" />
      </button>

      {/* Logout button */}
      <button
        onClick={onLogout}
        className="fixed bottom-[56px] right-8 bg-red-600/80 hover:bg-red-500/80 text-white p-4 rounded-full shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300 w-16 h-16 flex items-center justify-center z-50"
        style={{ boxShadow: '0 8px 20px rgba(0,0,0,0.4)' }}
        title="Uitloggen"
      >
        <LogOut className="w-8 h-8" />
      </button>
    </>
  );
};

export default DashboardSideButtons;
